import React from 'react';
import { Autocomplete, Box, TextField, TextFieldProps } from '@mui/material';
import { Control, Controller, FieldValues, RegisterOptions } from 'react-hook-form';

interface Props {
  control: Control<FieldValues, Record<PropertyKey, unknown>>;
  name: string;
  rules?: RegisterOptions;
  label: string;
  options: string[];
  inputProps?: TextFieldProps;
}

const FixedOptionSelector: React.FC<Props> = ({ label, options, inputProps, ...props }) => {
  return (
    <Controller
      {...props}
      defaultValue={null}
      render={({ field }) => (
        <Autocomplete
          {...field}
          options={options}
          onChange={(_, value) => {
            field.onChange(value || null);
          }}
          getOptionLabel={item => item}
          renderOption={(props, option) => {
            return (
              <Box {...props} component="li" key={option}>
                {option}
              </Box>
            );
          }}
          isOptionEqualToValue={(option, value) => {
            return value === undefined || option === value;
          }}
          renderInput={params => (
            <TextField
              {...params}
              label={label}
              margin="normal"
              variant="outlined"
              required={!!props.rules?.required}
              {...inputProps}
            />
          )}
        />
      )}
    />
  );
};

export default FixedOptionSelector;
